import { Antwoord, ValidatieParameter } from '@models/claims';
import { IBaseVraagboomResultaat, VraagboomAntwoord, VraagboomDateResultaat, VraagboomTimeResultaat } from '@models/vragenboom';
import { FormatHelper, ValidatieregelHelper } from '@services/public_api';
import { RegexValidator } from './regex.validator';

// @dynamic
export class TimeValidator {
  static isValidTime(antwoord: Antwoord, resultaat: VraagboomTimeResultaat, resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): boolean {
    if (!resultaat) {
      return false;
    }

    if (antwoord && !RegexValidator.isValidRegexAnswer(antwoord, FormatHelper.formatTime(resultaat.uren, resultaat.minuten))) {
      return false;
    }

    if (resultaat.uren < 0 || resultaat.uren >= 24 || resultaat.minuten < 0 || resultaat.minuten >= 60) {
      return false;
    }

    return this.isValidFuture(antwoord, resultaat, resultaten);
  }

  static isValidFuture(antwoord: Antwoord, resultaat: VraagboomTimeResultaat, resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): boolean {
    const toekomstValidator: ValidatieParameter = ValidatieregelHelper.get(antwoord.validatieParameters, 'DATUMTIJD_KLEINER_GELIJK');
    if (resultaten && toekomstValidator != null) {
      // Schadedatum;Schadetijd;HuidigeDatumTijd
      let parms = toekomstValidator.validatie_parameters.split(';');
      // zoek datum
      if (parms?.length === 3) {
        let datum = this.geefDatum(parms[0], resultaten);
        if (!datum) {
          return false;
        }

        datum.setHours(resultaat.uren);
        datum.setMinutes(resultaat.minuten);
        if (parms[2] === 'HuidigeDatumTijd') {
          return datum < new Date();
        }
      }
    }
    return true;
  }

  private static geefDatum(zoekVar: string, resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]) {
    let datumAntwoord: Date;
    if (zoekVar.indexOf('{') === -1) {
      zoekVar = '{' + zoekVar + '}';
    }

    resultaten.forEach(r => {
      if (!datumAntwoord && r.antwoorden.find(a => a.variabeleWaarde === zoekVar)) {
        datumAntwoord = (r.resultaat as VraagboomDateResultaat).value;
      }
    });
    return datumAntwoord;
  }
}
